import { FC } from 'react'
import { AppHead } from 'client/components/ProfileLayout/components/AppHead/AppHead'
import { ProfileLayout } from 'client/components/ProfileLayout/ProfileLayout'
import { ProfileOrdersPageContent } from 'client/contents/ProfileOrdersContent/ProfileOrdersContent'

type TProps = {}

const ProfileOrdersPage: FC<TProps> = () => {
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead />
      <ProfileOrdersPageContent />
    </article>
  )
}

// @ts-ignore
ProfileOrdersPage.layout = (page) => <ProfileLayout children={page}></ProfileLayout>

export default ProfileOrdersPage
